import { trackWithDefaultStage } from "@flights/et-universal";
import { BLACK_FRIDAY_EXLUDED_COUNTRIES } from "../../../constants";
import { isOfMetaOrigin, isOfPPCOrigin } from "../../../utils/marketing-url-params";
import useGlobalContext from "../../../hooks/useGlobalContext";

const useBlackFridayExp = (): boolean => {
  const { ipCountry = "" } = useGlobalContext();

  return (
    !isOfPPCOrigin() &&
    !isOfMetaOrigin() &&
    !BLACK_FRIDAY_EXLUDED_COUNTRIES.includes(ipCountry.toLowerCase()) &&
    !!trackWithDefaultStage("flights_web_cat_black_friday_index_2025", 1)
  );
};

export default useBlackFridayExp;
